'use strict';

const LoginPageLinks = {
    SignUp: "https://www.wolterskluwer.com/en/solutions/clinical-surveillance-compliance/newsletter-subscription-center?&utm_medium=partner_site&utm_source=solesource&utm_campaign=health_csc_solesource_loyalty_newsletter_",
    ContactUs: "https://www.wolterskluwer.com/en/solutions/clinical-surveillance-compliance/contact-us",
    AboutUs: "https://www.wolterskluwer.com/en/solutions/clinical-surveillance-compliance/about-us",
    SoleSource: "https://www.wolterskluwer.com/en/solutions/solesource",
    Solutions: "https://www.wolterskluwer.com/en/solutions",
    Home: "https://www.wolterskluwer.com/en",
    Twitter: "https://twitter.com/wkhealth",
    Linkedin: "https://www.linkedin.com/company/wolters-kluwer-health",
    Facebook: "https://www.facebook.com/WoltersKluwerHealth/",
    PrivacyCookies: "https://www.wolterskluwer.com/en/privacy-cookies",
    TermsOfUse: "https://www.wolterskluwer.com/en/terms-of-use"

};

export default LoginPageLinks;

